const popups = {
    trigersToggle: [
        {
            name: 'menu',
            open: [document.getElementById('openMenu')] as HTMLElement[],
            popup: document.getElementById('menu'),
            close: document.getElementById('closeMenu'),
            overlay: true
        },
        {
            name: 'sidebar',
            open: [document.getElementById('openSidebar')] as HTMLElement[],
            popup: document.getElementById('sidebarWrap'),
            close: document.getElementById('closeSidebar'),
            overlay: true
        },
        {
            name: 'search',
            open:  document.querySelectorAll('.jsopenSearch') as NodeListOf<HTMLElement>,
            popup: document.getElementById('productFinder'),
            close: document.getElementById('closeSearch'),
            overlay: true
        },



    ],
    clearFilters: document.getElementById('clearFilters'),
    overlay: document.getElementById('overlay')! as HTMLElement,
    close: document.querySelectorAll('.jsClose'),
    activClasse: [] as HTMLElement[],
    menuAdvert: document.getElementById('phoneAdvert'),

    init() {
        this.openPopupToggle();
        this.overlayClose();
        this.clearFilter();

    },
    clearFilter() {
        if (this.clearFilters) {
            let link = window.location;
            this.clearFilters.addEventListener('click', () => {
                window.location.replace(link.origin + link.pathname);
            });
        }

    },
    overlayClose() {
        this.overlay.addEventListener('click', () => {
            this.overlay.classList.remove('activeClass');
            document.documentElement.style.overflow = 'auto';
            document.body.classList.remove('activeClass');
            this.closeAll();
        });
    },

    setOverlay(open: HTMLElement | boolean, popup: HTMLElement | null, triger: HTMLElement, overlay = false) {

        if (open && popup && triger) {
            this.closeAll();
            if (overlay) {
                this.overlay.classList.add('activeClass');
            }
            if (window.innerWidth < 1200) {
                document.documentElement.style.overflow = 'hidden';
                document.body.classList.add('activeClass');
            }
            popup.classList.add('activeClass');
            triger.dataset.open = 'true';
            triger.classList.add('activeClass');
            this.activClasse.push(popup);
            this.activClasse.push(triger);
        } else {
            this.overlay.classList.remove('activeClass');
            triger.dataset.open = 'false';
            if (window.innerWidth < 1200) {
                document.documentElement.style.overflow = 'auto';
                document.body.classList.remove('activeClass');
            }
            this.closeAll();
        }
    },
    closeAll() {
        this.activClasse.forEach((item) => {
            item.classList.remove('activeClass');
            item.dataset.open = 'false';
        });
        this.activClasse = [];
    },
    openPopupToggle() {

        this.trigersToggle.forEach((item, index) => {

            if (item['open'].length > 0) {
                item['open'].forEach(el => {

                    if (item['popup'] && el) {

                        item['popup'].classList.add('init');
                        el.addEventListener('click', (e) => {
                            e.preventDefault();
                            if (el.dataset.open === 'false') {
                                this.setOverlay(true, item['popup'], el, item['overlay']);
                            } else {
                                this.setOverlay(false, item['popup'], el, item['overlay']);
                            }
                        })
                    }
                });

                if (item['close']) {
                    item['close'].addEventListener('click', () => {

                        item['open'].forEach(el => {
                            this.setOverlay(false, item['popup'], el);
                        });
                    })
                }
            }


        });
    },


}

export default popups;